import React, { useState, useEffect } from 'react';
import { Select, Tabs, Pagination } from 'antd';
import usePortalService from '../services/PortalService';
import { Link, useParams } from 'react-router-dom';
import separator from '../images/separator.svg';
import styled from "styled-components";
import { ReactionCandidateCard } from '../Components/CandidateCards/ReactionCandidateCard';
import { ManagerNavbar } from '../Components/Navbars';

import type { TabsProps } from 'antd';
import type { PaginationProps } from 'antd';
import { Reaction } from '../types';

const Container = styled.a`
    font-family: Open Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
`

const tabPages: TabsProps['items'] = [
    {
        key: '0',
        label: `Отклики`,
    },
    {
        key: '1',
        label: `Приглашения`,
    }
];

const optionsReplies = [
    { value: 8, label: 'Все' },
    { value: 1, label: 'Приглашения' },
    { value: 3, label: 'Просмотрено' },
    { value: 4, label: 'Не просмотрено'},
    { value: 2, label: 'Отказ'}
]
  
const optionsInvitations = [
    { value: 5, label: `Приглашение отправлено`},
    { value: 6, label: `Приглашение принято` },
    { value: 7, label: `Приглашение отклонено` }
]

export const ReactionsByVacancy = () => {
    const {getReactionsByVacancy} = usePortalService();

    const { id: vacancyId } = useParams();

    const [vacancyName, setVacancyName] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const [reactions, setReactions] = useState<Reaction[]>([]);

    const [page, setPage] = useState(1);
    const reactionsPageSize = 20;

    const [reactionsHeader, setReactionsHeader] = useState('');

    const [selectOptions, setSelectOptions] = useState(optionsReplies);
    const [selectedStatus, setSelectedStatus] = useState(8);
    const [filterOption, setFilterOption] = useState(8);

    const [isLoaded, setIsLoaded] = useState(false);

    const tabHandler = (key: string) => {
        setPage(1)
        if (parseInt(key) === 1){
            setFilterOption(5)
            setSelectOptions(optionsInvitations)
            setSelectedStatus(5)
        } else {
            setFilterOption(8)
            setSelectOptions(optionsReplies)
            setSelectedStatus(8)
        }
        findReactions(1, 8);
    };

    const selectHandler = (e: number) => {
        setFilterOption(e);
        setSelectedStatus(e);
        findReactions(page, e);
    }

    const pageHandler: PaginationProps['onChange'] = (pageNumber) => {
        setPage(pageNumber)
        findReactions(pageNumber, selectedStatus);
    };

    const updateHeader = (count: number) => {
        if (count === 0) {
            setReactionsHeader("Нет откликов");
        } else {
            let term = "";
            const number = count % 10;

            if (number > 4 || number === 0) {
                term = "ов"
            } else if (number > 1 ) {
                term = "а"
            }

            setReactionsHeader(`${count} отклик${term}`)
        }
    }

    useEffect(() => {
        findReactions(1, 8);
    }, [])

    const findReactions = async (page: number, filterOption: number) => {
        setIsLoaded(false);
        const offset = (page - 1) * reactionsPageSize;

        const result = await getReactionsByVacancy(vacancyId, {
            offset,
            limit: reactionsPageSize,
            sortBy: "string",
            sortOrder: 0,
            filter: {
                filterOption
            }
        })

        const totalCount = result.vacancy.reactions.totalCount;
        setVacancyName(result.vacancy.name);
        setTotalCount(totalCount);
        updateHeader(totalCount);
        setReactions(result.vacancy.reactions.items);
        setIsLoaded(true);
    }
    

    return (
        <>
            <ManagerNavbar />
            <div className="inner-tab-container" style={{maxWidth:'983px'}}>
                <Container style={{marginBottom:'12px'}}>
                    <Link to="/vacanciesByCompany" style={{color: '#76838F'}}> Вакансии </Link>
                    <img src={separator} sizes="22px" alt=''/>
                    <Link to={`/vacancy/${vacancyId}`} style={{color: '#45505A'}}> {vacancyName} </Link>
                </Container>
                <h1> {reactionsHeader} </h1>
                <div className="candidates-container">
                    <Tabs items={tabPages} onChange={tabHandler} style={{paddingRight:'8px'}} />
                    <Select 
                        style={{marginBottom:'24px', maxWidth: '550px', minWidth: '200px'}}
                        value={selectedStatus}
                        onChange={selectHandler}
                        options={selectOptions}
                    />
                    {(reactions.length === 0 && isLoaded) && <p style={{paddingTop:'100px', paddingLeft: '100px'}}> Нет откликов в данной категории. </p>}
                    {reactions.map(item => (
                        <ReactionCandidateCard 
                            key={item.id}
                            reaction={item}
                            candidate={item.profile}
                            isView={item.isView}
                        />
                    ))}
                    <div>
                        {(totalCount > reactionsPageSize && isLoaded) && 
                            <Pagination 
                                current={page} 
                                total={totalCount} 
                                onChange={pageHandler} 
                                showSizeChanger={false} 
                                pageSize={reactionsPageSize}  
                                style={{marginLeft:'30%', marginRight:'auto'}}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
}